import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Toast } from 'vant';
import router from '../router';
const service = axios.create({
  baseURL: "https://usababyinfo.com/index.php?s=/",
  // baseURL: "http://wuyoushiyao.com:8021/index.php?s=/",
  timeout: 20000 // request timeout
})

service.interceptors.request.use(
  config => {
    config.headers['Access-Token'] = getToken()
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status !== 200) {
      Toast(res.message);
      if(res.status === 401){
        localStorage.clear();
        setTimeout(function (){
         router.push({path: '/wode'});
        },1000)
        return res
      }else{
        return Promise.reject(new Error(res.message || 'Error'))
      }
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)
export default service




// WEBPACK FOOTER //
// ./src/utils/request.js